import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function MeetingDateCell({ row }) {
  const { t } = useTranslation('MeetingDateCell')
  const feedback = row.original

  const meetingDate = feedback.meeting_date
  const formattedMeetingDate = new Date(
    feedback.meeting_date,
  ).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'numeric',
    day: '2-digit',
  })

  const completed = meetingDate && feedback.completed_at

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">
          <div>
            <span className="font-bold">
              {completed ? `${t('completed')} - ` : ''}
            </span>
            {meetingDate ? formattedMeetingDate : t('no_meeting')}
          </div>
        </div>
      </div>
    </div>
  )
}
